module.exports = __webpack_public_path__ + "img/historia7.0a3cb4a3.jpg";